module.exports = __webpack_public_path__ + "static/media/scene8_sama2.34230942.wav";